export const environment = {
  production: true,
  oidSistema: 5928,
  version: '01.00.01',
  hostURL: 'api.backend' + '/credenciamentooperadora',
  hostUrlEAutoriza: 'api.eautoriza' + '/eAutorizaService/rest',
  hostUrlEAutorizaWeb: 'api.webeautoriza'
};
